import React, { useState, useMemo } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import { getMarkedTextMode } from '../../utils/richTextUtils';
import Compiler from '../compiler/Compiler';

import './style.css';

const KovMarkedText = ({ text, dataHref, modes, compilerOptions, onClick, onHover }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [explanation, setExplanation] = useState('');
  const mode = getMarkedTextMode(dataHref, modes);

  const onClickHandler = () => {
    onClick?.(dataHref, text, setExplanation);
    if (onClick) setIsPopoverOpen(!isPopoverOpen);
  };

  const mouseEnterHandler = () => {
    onHover?.(dataHref, text, setExplanation);
    if (onHover) setIsPopoverOpen(true);
  };
  const mouseLeaveHandler = () => {
    setIsPopoverOpen(false);
  };

  const content = useMemo(() => <Compiler text={text} options={compilerOptions} />, [text]);

  return (
    <div className={`kov-marked-text ${mode}`} id={dataHref}>
      <Popover
        isOpen={isPopoverOpen}
        positions={['top', 'bottom', 'left', 'right']}
        onClickOutside={() => setIsPopoverOpen(false)}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowColor={'black'}
            arrowSize={5}
            arrowStyle={{ opacity: 0.7 }}
          >
            <div className="kov-marked-text-popover">{explanation}</div>
          </ArrowContainer>
        )}
      >
        <div
          onMouseEnter={mouseEnterHandler}
          onMouseLeave={mouseLeaveHandler}
          onClick={onClickHandler}
        >
          {content}
        </div>
      </Popover>
    </div>
  );
};

export default KovMarkedText;
